"use client";

import React from "react";
import { InfiniteMovingCards } from "./UI/infinite-moving-cards";

export function InfiniteMovingCardsDemo() {
  const testimonials = [
    { quote: "After switching to Mansafa cotton towels, my daily routine feels so much more luxurious. The softness and absorbency are unmatched.", name: "Aarav Mehta", title: "Hotel Manager" },
    { quote: "Mansafa bamboo towels are a game-changer for my spa. Clients always compliment their silky softness and eco-friendly feel.", name: "Sophia D'Souza", title: "Spa Owner" },
    { quote: "The Ihram towels from Mansafa were lightweight and breathable. They gave me great comfort during my Hajj journey.", name: "Mohammed Ali", title: "Entrepreneur" },
    { quote: "As a retailer, I trust Mansafa because their cotton towels are consistently durable and my customers keep coming back for more.", name: "Rajesh Patel", title: "Retailer" },
    { quote: "I purchased Mansafa bamboo towels for my family, and they love them. Soft on the skin and wash beautifully every time.", name: "Fatima Khan", title: "Businesswoman" },
    { quote: "Hotels need towels that last, and Mansafa delivers exactly that. High-quality and stylish, they elevate the guest experience.", name: "Elena Rodriguez", title: "Hotel Owner" },
    { quote: "Mansafa Ihram towels gave me peace of mind during pilgrimage. Lightweight, absorbent, and perfectly designed for the sacred journey.", name: "Abdul Rahman", title: "Pilgrim" },
    { quote: "I’ve tried many brands, but Mansafa’s premium cotton towels are truly the best. They balance luxury and durability perfectly.", name: "Nisha Verma", title: "Interior Designer" },
  ];

  return (
    <div
      className="w-full 
        h-[32rem] sm:h-[36rem] lg:h-[40rem] 
        px-2 sm:px-6 
        flex flex-col items-center justify-center 
        antialiased 
        bg-white dark:bg-black 
        dark:bg-grid-white/[0.05] 
        relative overflow-hidden"
    >
      <InfiniteMovingCards items={testimonials} direction="right" speed="fast" />
    </div>
  );
}
